import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Employer } from '../../models/employer/employer';

@Injectable({
  providedIn: 'root',
})
export class EmployerNamesService {
  private employersSubject = new BehaviorSubject<Employer[]>([]); // Initialize with an empty array
  employers$ = this.employersSubject.asObservable(); // Observable for components to subscribe to

  constructor() {}

  // Method to update the employer list in the service
  setEmployers(employers: Employer[]) {
    this.employersSubject.next(employers); // Update the BehaviorSubject with new data
  }

  // Optional: Method to fetch the current employers list
  getEmployers() {
    return this.employersSubject.value;
  }
}
